import {
  Icons,
  Status,
} from "@components/index";
import { useStatus } from "@hooks/index";

interface StatusFragmentType {
  status?: Sentinel.Enumerators.ProcessExecutionStatus,
  plannedExecutionStart?: string
}

const StatusFragment: React.FC<React.HTMLAttributes<HTMLDivElement> & StatusFragmentType> = ({ status, plannedExecutionStart }) => {
  const data = useStatus(status, plannedExecutionStart);

  return (
    <Status variant={data.variant}>
      <Icons icon={data.icon} size="md" />
      {data.text}
    </Status>
  );
};

export default StatusFragment;